<template>

  <div>

    <TypeChecklistItemDialog :no-option-add="noOptionAdd" @onSubmit="onItemDialog"/>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="typeEnvironmentItemId" :primary-key="form.typeEnvironmentItemId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Itens" sortable
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit"
                 @onItemRead="onItemReadDefault"
                 @onItemDelete="onItemDeleteDefault">

      <template #default>

        <t-input v-model="form.typeEnvironmentItemId" hidden/>

        <b-col cols="12" class="mb-2">

          <b-row>

            <b-col xl="12">

              <b-row>

                <b-col cols="6">

                  <t-input
                      v-model="form.typeChecklistItemId"
                      select
                      v-if="command === 'insert'"
                      :options="itemOptions"
                      label="Item"
                      :add-error="error.typeChecklistItemId"
                      required>

                    <template #no-options="{search}">
                      <b-link @click="addNoOption('modal-type-checklist-item',search)">Cadastrar Item</b-link>
                    </template>

                    <template #input-group-append>
                      <t-button title="Adicionar Item" @click="openDialogForm('modal-type-checklist-item')"
                                icon-plus/>
                    </template>

                  </t-input>

                  <t-input
                      v-else
                      v-model="form.typeChecklistItemId"
                      fixed
                      select
                      :options="itemOptions"
                      label="Item"
                      :add-error="error.typeChecklistItemId"
                      required/>

                  <!--
RETIRADO EM 15/01/2025, POIS GERA INCONSISTÊNCIA COM APONTAMENTOS ANTIGOS, SENDO NECESSÁRIO ALGUMA FERRAMENTA DE MIGRAÇÃO DE ITENS DE APONTAMENTOS EM MASSA.
INDICANDO O NOVO ITEM QUE SUBSTITUIRA O ANTIGO QUE SERÁ INATIVO.
<t-input-status v-model="form.status"/>
-->
                  <!--               <t-input-status v-if="isUpdate()" v-model="form.status"/>-->

                  <b-form-checkbox v-if="isInsert()" class="col-sm-12 ml-2 mb-3" v-model="form.checklistReinstall"
                                   switch>
                    Inserir item nas inspeções em andamento relacionadas?
                    <t-help
                        title="Você poderá utilizar o recurso de reinstalação de inspeção e assim inserir este novo item vinculado ao modelo de ambiente nas respectivas inspeções em andamento. Não se esqueça de utilizar o procedimento de Reinstalação no App após todas as revisões de mapeamento."/>
                  </b-form-checkbox>


                </b-col>

                <b-col xl="6" class="button-form-inline">

                  <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

                  <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                    {{ t('go-back') }}
                  </b-link>

                </b-col>

              </b-row>

            </b-col>

          </b-row>

          <b-row>

            <b-link class="ml-3 mt-2" @click="confirmChangeOrderByName()">
              <b-icon-list-nested class="mr-2"/>
              Organizar itens em ordem alfabética
            </b-link>


          </b-row>


        </b-col>

      </template>


      <template #item(item)="{item}">

        {{ item.item }}
        <small v-if="item.status === 2"><br/>(Inativo)</small>

      </template>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import TypeChecklistItemService from "@/services/modules/checklist/TypeChecklistItem.service";
import TypeChecklistItemDialog from "@/views/modules/checklist/TypeChecklistItemDialog";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList, TypeChecklistItemDialog},
  name: 'TypeEnvironmentItem',
  data() {
    return {
      path: "place/type-environment-item", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "typeEnvironmentId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "typeEnvironmentItemId", keyDelete: "typeEnvironmentItemId"},
        {key: "item", label: "Item", cols: "4"},

      ],
      form: {
        typeEnvironmentId: this.foreignKey,
        typeEnvironmentItemId: 0,
        typeChecklistItemId: 0,
        checklistReinstall: true,
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        typeChecklistItemId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      itemOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.form.status = 1
      this.form.checklistReinstall = true
      this.form.enableAutoImportedItems = false


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

      this.userAuth.validation.validationUpdate = false //Remove a validação de alteração manualmente, pois se remover no back-end não será possível reordenar

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.typeEnvironmentItemId)

    },

    async mountedList() {

      await TypeChecklistItemService.selectList().then((list) => {
        this.itemOptions = list
      }).catch(error => this.responseError(error))

      this.itemOptions = this.itemOptions.filter(option =>
          !this.items.some(item => item.typeChecklistItemId === option.value)
      )

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onItemDialog(itemInserted) {

      this.form.typeChecklistItemId = itemInserted.value
      this.itemOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },
    async confirmChangeOrderByName() {

      //Inseriro sem confirmação para facilitar operação do usuário
      await http.post(this.getPath() + "/changeOrderByName/" + this.foreignKey, "")
          .then(() => {
            ui.toast(this, 'Sucesso!', 'Ordem atualizada com sucesso!')
            this.getList()
          })
          .catch(error => {
            this.responseError(error)
          })

      /*ui.msgConfirm(this,'Confirmação','Tem certeza que deseja alterar a ordem dos item para ordem alfabética?',async ()=>{

        await http.post(this.getPath()+"/changeOrderByName/"+this.foreignKey, "")
            .then(() => {
              ui.toast(this,'Sucesso!','Ordem atualizada com sucesso!')
              this.getList()
            })
            .catch(error => {
              this.responseError(error)
            });
      }, "Sim")*/

    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
